import { Trans } from "@lingui/react/macro";

export function PaymentReturn() {
    return (
        <div className="size-full flex items-center justify-center text-center">
            <div>
                <Trans>Payment authorization check finished.</Trans>
                <br />
                <br />
                <Trans>You can close this page.</Trans>
            </div>
        </div>
    );
}
